import React from 'react';

import SupportedLocations from '.';

const InternalAdmin = (props) => {
  return <SupportedLocations displayBreadcrumbs={false} displayTitle={false} {...props} />;
};

export default InternalAdmin;
